<template>
  <div class="about">
    <div class="about-box">
      <div class="about-title-box">
        <div class="about-us">关于我们</div>
      </div>
    </div>
    <div class="about-content">
      <div class="about-content-box">
        <div class="company-profile">
          <h2 class="company-profile-title">公司简介</h2>
          <div class="company-profile-box">
            <div class="company-profile-left" id="wrapper-img">
              <img src="../assets/img/about_01.jpg" />
            </div>
            <div class="company-profile-right" id="wrapper-text">
              <div class="top-border"></div>
              <div class="company-profile-test">
                <div
                  class="company-profile-content"
                >华云声隶属于深圳房讯通信息技术有限公司，是一家专做征收的科技及服务公司，通过信息化系统+第三方专业服务，推行高效、阳光、有序的征收。</div>
                <div
                  class="company-profile-content"
                >云征收团队多年来致力于房屋征收（棚户区改造）、城市更新、专注提供政策研究、顶层设计和项目实操实务、全过程咨询顾问服务等服务，秉承”高位协调，系统分析；专业为本，科技助力“理念，借助专业航拍技术自主研发智慧征收的相关软硬件产品，已为数百家各地征收办、评估机构赋能，提供相应技术支持。</div>
              </div>
              <div class="bottom-boder"></div>
            </div>
          </div>
        </div>
        <div class="contact-information">
          <h2 class="company-profile-title">联系方式</h2>
          <div class="contact-information-detail">
            <div>公司地址 : 深圳市南山区粤海街道高新区社区高新南七道015号深港产学研基地W106</div>
            <div>联系方式: 134-1187-0085 张先生</div>
            <div>联系邮箱 : zhangyj@fxtcn.com</div>
          </div>
          <div class="contact-information-img">
            <img src="../assets/img/address.png" />
            <div class="contact-information-address">深港产学研基地W106</div>
            <div class="contact-information-positioning">
              <img src="../assets/img/sjx.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="about-certification">
        <div class="about-certification-box">
          <div class="about-certification-one">
            <img src="../assets/img/about_zhuzq01.png" />
          </div>
          <div class="about-certification-one">
            <img src="../assets/img/about_zhuzq02.png" />
          </div>
          <div class="about-certification-one">
            <img src="../assets/img/about_zhuzq03.png" />
          </div>
          <div class="about-certification-one">
            <img src="../assets/img/about_zhuzq04.png" />
          </div>
          <div class="about-certification-one">
            <img src="../assets/img/about_zhuzq05.png" />
          </div>
          <div class="about-certification-one">
            <img src="../assets/img/about_zhuzq06.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    // console.log(x);
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft company-profile-left'
    );
    var y = document.getElementById('wrapper-text');
    // console.log(x);
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft animate__fadeInRight company-profile-right'
    );
  }
};
</script>
<style>
.about {
  width: 100%;
}
.about-box {
  width: 100%;
  height: 650px;
  background: url('../assets/img/about_bg.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.about-title-box {
  width: 1500px;
  margin: auto;
  margin-top: 164px;
}
.about-us {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
  text-align: right;
  margin-right: 332px;
}
.about-content {
  background: #ffffff;
}
.about-content-box {
  width: 1500px;
  margin: auto;
}
.company-profile {
  width: 100%;
  height: 530px;
}
.company-profile-title {
  text-align: center;
  font-size: 28px;
}
.company-profile-box {
  display: flex;
  height: 450px;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.company-profile-left {
  width: 720px;
  height: 450px;
  padding-right: 59px;
}
.company-profile-left img {
  width: 720px;
  height: 450px;
}
.company-profile-right {
  width: 720px;
  height: 450px;
  flex-wrap: nowrap;
  position: relative;
}
.top-border {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 360px;
  height: 220px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 189, 183, 1);
  border-left: 0px;
  border-bottom: 0px;
  border-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.bottom-boder {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 360px;
  height: 220px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 189, 183, 1);
  border-top: 0px;
  border-right: 0px;
  border-radius: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.company-profile-test {
  position: absolute;
  width: 620px;
  height: 288px;
  z-index: 999;
  top: 56px;
  left: 56px;
}
.company-profile-content {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 18px;
  line-height: 40px;
  text-indent: 32px;
  letter-spacing: 2px;
}
.contact-information-detail {
  font-family: '微软雅黑';
  font-style: normal;
  font-size: 18px;
  line-height: 36px;
}
.contact-information-img img {
  margin-top: 15px;
  width: 1500px;
  height: 330px;
  padding-bottom: 15px;
}
.contact-information-img {
  position: relative;
}
.contact-information-address {
  position: absolute;
  left: 48%;
  top: 38%;
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: inherit;
  background-color: rgba(51, 51, 51, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(51, 51, 51, 1);
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #ffffff;
  text-align: center;
}
.about-certification {
  width: 100%;
  height: 400px;
  background: url('../assets/img/bg.png') no-repeat center;
  background-size: 100% 400px;
  overflow: hidden;
}
.about-certification-box {
  width: 1500px;
  display: flex;
  flex-wrap: nowrap;
  box-sizing: border-box;
  height: 300px;
  margin: auto;
  margin-top: 50px;
}
.about-certification-one {
  width: 218px;
}
.about-certification-one:nth-child(2),
.about-certification-one:nth-child(3),
.about-certification-one:nth-child(4),
.about-certification-one:nth-child(5),
.about-certification-one:nth-child(6) {
  margin-left: 39px;
}
.contact-information-positioning {
  position: absolute;
  left: 51.5%;
  top: 44%;
  width: 20px;
  height: 10px;
}
.contact-information-positioning img {
  width: 20px;
  height: 10px;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .about-title-box,
  .about-content-box,
  .about-certification-box {
    width: 1200px !important;
  }
  .contact-information-img img {
    width: 1200px !important;
  }
  .about-us {
    margin-right: 150px !important;
  }
  .company-profile-left {
    width: 560px !important;
    height: 349px !important;
    padding-right: 59px;
  }
  .company-profile-left img {
    width: 560px !important;
    height: 349px !important;
  }
  .company-profile-right {
    width: 560px !important;
    height: 349px !important;
  }
  .top-border {
    width: 260px !important;
    height: 158px !important;
  }
  .bottom-boder {
    width: 260px !important;
    height: 158px !important;
  }
  .company-profile-test {
    width: 520px !important;
    height: 242px !important;
    top: 25px !important;
    left: 25px !important;
  }
  .contact-information-positioning img {
    width: 20px !important;
    height: 10px !important;
  }
  .about-certification-one {
    width: 16% !important;
    height: 300px;
  }
  .about-certification-one:nth-child(2),
  .about-certification-one:nth-child(3),
  .about-certification-one:nth-child(4),
  .about-certification-one:nth-child(5),
  .about-certification-one:nth-child(6) {
    margin-left: 15px !important;
  }
  .about-certification-one img{
    width: 100% !important;
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/about.vue